<script>
import { mapGetters } from 'vuex';
import ReglementApi from '@/api/reglement';
import { find } from 'lodash';

export default {
  name: 'CardsListItemLignePanier',

  props: {
    ligne: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    loading: true,
    loaded: false,
    modesReglements: [],
    domiciliationsBancaires: [],
    codeReglement: null,
    numDomiciliationBancaire: null,
    dateEcheance: null,
    tauxEscompte: null,
    regtHisto: [],
    accesRegt: true
  }),

  computed: {
    ...mapGetters({
      tiers: 'user/tiers'
    })
  },

  watch: {
    codeReglement () {
      this.selectModeRegt();
    },
    numDomiciliationBancaire () {
      this.selectDb();
    }
  },

  created () {
    ReglementApi.getPropositionReglementTiers(this.tiers.numTiers, this.tiers.typeTiers, 'AGR', this.ligne.numArticle, this.ligne.codeTypeArticle, this.ligne.datePrevueLivraison, this.ligne.numLot).then(
      reglements => {
        this.modesReglements = reglements;
        const regtDefaut = find(reglements, { parDefaut: true });
        if (regtDefaut) {
          this.codeReglement = regtDefaut.codeRegt;
        }

        this.selectModeRegt();
        this.selectDb();
      }
    ).finally(
      () => {
        this.loading = false;
        this.$emit('loaded');
      }
    );
  },
  methods: {
    selectModeRegt () {
      const enreg = find(this.modesReglements, { codeRegt: this.codeReglement }) || { domiciliationsBancaires: [] };
      this.domiciliationsBancaires = enreg.domiciliationsBancaires;

      if (this.domiciliationsBancaires && this.domiciliationsBancaires.length) {
        const db = find(this.domiciliationsBancaires, { numDomiciliationBancaire: this.ligne.numDomiciliationBancaire });
        if (db) {
          this.numDomiciliationBancaire = db.numDomiciliationBancaire;
        } else {
          this.numDomiciliationBancaire = this.domiciliationsBancaires[0].numDomiciliationBancaire;
        }
      } else {
        this.numDomiciliationBancaire = null;
      }

      this.dateEcheance = enreg.datePrevEche;
      this.tauxEscompte = enreg.tauxEscompte;

      this.changeEvent();
    },

    afficheReglement () {
      this.accesRegt = false;
    },

    selectDb () {
      this.changeEvent();
    },
    changeEvent () {
      this.$emit('changeReglement', { codeReglement: this.codeReglement, numDomiciliationBancaire: this.numDomiciliationBancaire });
    },
    fireCloneReglementEvent () {
      this.$emit('cloneReglement', this.ligne);
    },
    applyModeReglementIfPossible (codeModeReglement, numDomiciliationBancaire) {
      const modeReglement = find(this.modesReglements, { codeRegt: codeModeReglement });

      if (modeReglement) {
        this.codeReglement = codeModeReglement;
        this.numDomiciliationBancaire = numDomiciliationBancaire;
        this.changeEvent();
        return true;
      } else {
        return false;
      }
    }
  }

};
</script>
<template>
  <div class="list-ligne">
    <div class="content-row block-article">
      <div>
        <strong>{{ ligne.libelleArticle }}</strong><sub class="num-article">{{ ligne.numArticle }}</sub>
      </div>
      <div class="primary--text">
        <div v-if="ligne.codeUniteArticle === 'T'">
          <v-icon color="primary">
            mdi-weight
          </v-icon>
          <div class="no-wrap">
            {{ ligne.quantiteCommande | formatDecimal(3) }} t
          </div>
        </div>
        <div v-else>
          {{ ligne.quantiteCommande }}
        </div>
      </div>
    </div>
    <div class="content-row secondary--text">
      <div v-if="ligne.supplementations">
        <div
          v-for="(supp, index) in ligne.supplementations"
          :key="index"
        >
          {{ supp.libelleArticle }}
        </div>
      </div>
      <div v-if="ligne.mineraux">
        <div
          v-for="(mineral, index) in ligne.mineraux"
          :key="index"
        >
          {{ mineral.libelleArticle }} {{ mineral.quantiteCommande }} %
        </div>
      </div>
    </div>
    <div
      style="flex-wrap:wrap;"
      class="infos-lieu-container primary--text content-row v-center"
    >
      <v-icon color="primary">
        mdi-home
      </v-icon>
      <span
        v-if="ligne.codeTypeSilo1"
        class="avoidwrap"
      >
        <RefValue
          :code="ligne.codeTypeSilo1"
          type="TYPE_SILO"
        />
      </span>
      <span
        v-if="ligne.codeTypeSilo2"
        class="avoidwrap"
      >
        <RefValue
          :code="ligne.codeTypeSilo2"
          type="TYPE_SILO"
        />
      </span>
      <span
        v-if="ligne.codeTypeSilo3"
        class="avoidwrap"
      >
        <RefValue
          :code="ligne.codeTypeSilo3"
          type="TYPE_SILO"
        />
      </span>
    </div>

    <v-divider class="separation" />

    <Loader
      v-if="loading"
      inline
      :size="25"
    />
    <div
      v-else
      class="bloc-regt content-row"
    >
      <div class="reglement-select">
        <div class="secondary--text">
          Mode de règlement
        </div>
        <v-select
          v-if="modesReglements"
          v-model="codeReglement"
          :items="modesReglements"
          :item-text="regt=>regt.libelle"
          :item-value="regt=>regt.codeRegt"
          :disabled="accesRegt"
          hide-details
        />
      </div>

      <div
        class="reglement"
        :class="{'ml-10':!isMobile}"
      >
        <div class="secondary--text">
          Taux escompte
        </div>
        <div>
          {{ tauxEscompte }} %
        </div>
      </div>
      <div
        class="reglement"
        :class="{'ml-10':!isMobile}"
      >
        <div class="secondary--text">
          Date échéance
        </div>
        <div>
          {{ dateEcheance | date }}
        </div>
      </div>

      <div
        v-if="domiciliationsBancaires && domiciliationsBancaires.length"
        class="reglement-select"
        :class="{'ml-10':!isMobile}"
      >
        <div class="secondary--text">
          Domiciliation bancaire
        </div>
        <span v-if="domiciliationsBancaires.length === 1">
          <span class="mr-4">{{ domiciliationsBancaires[0].numeroCompte }}</span>
          <span>{{ domiciliationsBancaires[0].nomBanque }}</span>
        </span>
        <v-select
          v-else
          v-model="numDomiciliationBancaire"
          :items="domiciliationsBancaires"
          :item-text="db=>(db.numeroCompte || '') + '    ' + (db.nomBanque || '')"
          :item-value="db=>db.numDomiciliationBancaire"
          :disabled="accesRegt"
          hide-details
        />
      </div>
      <div class="spacer" />

      <div>
        <v-btn
          outlined
          color="secondary"
          class="mr-3 mt-2"
          title="Modifier le mode de réglement"
          @click="afficheReglement"
        >
          <span
            v-if="isMobile"
            class="mr-0"
          >Modifier</span>
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
        <v-btn
          outlined
          color="secondary"
          class="mt-2"
          title="Appliquer ce mode de réglement aux autres lignes"
          @click="fireCloneReglementEvent"
        >
          <span
            v-if="isMobile"
            class="mr-2"
          >Dupliquer</span>
          <v-icon>mdi-content-duplicate</v-icon>
        </v-btn>
      </div>
    </div>

    <div>
      <div class="infos">
        <slot
          name="infos"
          :ligne="ligne"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list-ligne {
  padding: 0.5em 1em;
  width: 100%;
}
.block-article {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.infos-lieu-container {
  span {
    margin-right: 0.58em;
    vertical-align: sub;
  }
}

.infos {
  font-style: italic;
  font-size: 0.9em;
}

.bloc-regt {
  display: flex;
  flex-direction: row;

  .spacer {
    flex-grow: 1;
  }

  .reglement {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 10px;
  }
  .reglement-select {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 10px;
    width: 25vw;
  }
}

.reglement-libelle {
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }
}

.separation {
  margin-top: 10px;
  margin-bottom: 10px;
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .bloc-regt {
    flex-direction: column;
    .reglement {
      flex-direction: row;
      justify-content: space-between;
      margin-top: 10px;
    }
    .reglement-select {
      flex-direction: column;
      margin-top: 10px;
      width: 85vw;
    }
  }
}
</style>
